// source: permissionmessages.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var proto = {};

goog.exportSymbol('CacheRole', null, proto);
goog.exportSymbol('ExplicitPermissions', null, proto);
goog.exportSymbol('Permissions', null, proto);
goog.exportSymbol('Permissions.KindCase', null, proto);
goog.exportSymbol('PermissionsType', null, proto);
goog.exportSymbol('PermissionsType.All', null, proto);
goog.exportSymbol('PermissionsType.CacheItemSelector', null, proto);
goog.exportSymbol('PermissionsType.CacheItemSelector.KindCase', null, proto);
goog.exportSymbol('PermissionsType.CachePermissions', null, proto);
goog.exportSymbol('PermissionsType.CachePermissions.CacheCase', null, proto);
goog.exportSymbol('PermissionsType.CachePermissions.CacheItemCase', null, proto);
goog.exportSymbol('PermissionsType.CacheSelector', null, proto);
goog.exportSymbol('PermissionsType.CacheSelector.KindCase', null, proto);
goog.exportSymbol('PermissionsType.KindCase', null, proto);
goog.exportSymbol('PermissionsType.TopicPermissions', null, proto);
goog.exportSymbol('PermissionsType.TopicPermissions.CacheCase', null, proto);
goog.exportSymbol('PermissionsType.TopicPermissions.TopicCase', null, proto);
goog.exportSymbol('PermissionsType.TopicSelector', null, proto);
goog.exportSymbol('PermissionsType.TopicSelector.KindCase', null, proto);
goog.exportSymbol('SuperUserPermissions', null, proto);
goog.exportSymbol('TopicRole', null, proto);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Permissions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Permissions.oneofGroups_);
};
goog.inherits(proto.Permissions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Permissions.displayName = 'proto.Permissions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ExplicitPermissions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ExplicitPermissions.repeatedFields_, null);
};
goog.inherits(proto.ExplicitPermissions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ExplicitPermissions.displayName = 'proto.ExplicitPermissions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PermissionsType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.PermissionsType.oneofGroups_);
};
goog.inherits(proto.PermissionsType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PermissionsType.displayName = 'proto.PermissionsType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PermissionsType.All = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.PermissionsType.All, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PermissionsType.All.displayName = 'proto.PermissionsType.All';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PermissionsType.CacheSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.PermissionsType.CacheSelector.oneofGroups_);
};
goog.inherits(proto.PermissionsType.CacheSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PermissionsType.CacheSelector.displayName = 'proto.PermissionsType.CacheSelector';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PermissionsType.CacheItemSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.PermissionsType.CacheItemSelector.oneofGroups_);
};
goog.inherits(proto.PermissionsType.CacheItemSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PermissionsType.CacheItemSelector.displayName = 'proto.PermissionsType.CacheItemSelector';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PermissionsType.CachePermissions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.PermissionsType.CachePermissions.oneofGroups_);
};
goog.inherits(proto.PermissionsType.CachePermissions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PermissionsType.CachePermissions.displayName = 'proto.PermissionsType.CachePermissions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PermissionsType.TopicSelector = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.PermissionsType.TopicSelector.oneofGroups_);
};
goog.inherits(proto.PermissionsType.TopicSelector, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PermissionsType.TopicSelector.displayName = 'proto.PermissionsType.TopicSelector';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PermissionsType.TopicPermissions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.PermissionsType.TopicPermissions.oneofGroups_);
};
goog.inherits(proto.PermissionsType.TopicPermissions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PermissionsType.TopicPermissions.displayName = 'proto.PermissionsType.TopicPermissions';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Permissions.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.Permissions.KindCase = {
  KIND_NOT_SET: 0,
  SUPER_USER: 1,
  EXPLICIT: 2
};

/**
 * @return {proto.Permissions.KindCase}
 */
proto.Permissions.prototype.getKindCase = function() {
  return /** @type {proto.Permissions.KindCase} */(jspb.Message.computeOneofCase(this, proto.Permissions.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Permissions.prototype.toObject = function(opt_includeInstance) {
  return proto.Permissions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Permissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Permissions.toObject = function(includeInstance, msg) {
  var f, obj = {
    superUser: jspb.Message.getFieldWithDefault(msg, 1, 0),
    explicit: (f = msg.getExplicit()) && proto.ExplicitPermissions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Permissions}
 */
proto.Permissions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Permissions;
  return proto.Permissions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Permissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Permissions}
 */
proto.Permissions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.SuperUserPermissions} */ (reader.readEnum());
      msg.setSuperUser(value);
      break;
    case 2:
      var value = new proto.ExplicitPermissions;
      reader.readMessage(value,proto.ExplicitPermissions.deserializeBinaryFromReader);
      msg.setExplicit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Permissions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Permissions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Permissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Permissions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.SuperUserPermissions} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExplicit();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.ExplicitPermissions.serializeBinaryToWriter
    );
  }
};


/**
 * optional SuperUserPermissions super_user = 1;
 * @return {!proto.SuperUserPermissions}
 */
proto.Permissions.prototype.getSuperUser = function() {
  return /** @type {!proto.SuperUserPermissions} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.SuperUserPermissions} value
 * @return {!proto.Permissions} returns this
 */
proto.Permissions.prototype.setSuperUser = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.Permissions.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Permissions} returns this
 */
proto.Permissions.prototype.clearSuperUser = function() {
  return jspb.Message.setOneofField(this, 1, proto.Permissions.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Permissions.prototype.hasSuperUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ExplicitPermissions explicit = 2;
 * @return {?proto.ExplicitPermissions}
 */
proto.Permissions.prototype.getExplicit = function() {
  return /** @type{?proto.ExplicitPermissions} */ (
    jspb.Message.getWrapperField(this, proto.ExplicitPermissions, 2));
};


/**
 * @param {?proto.ExplicitPermissions|undefined} value
 * @return {!proto.Permissions} returns this
*/
proto.Permissions.prototype.setExplicit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.Permissions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Permissions} returns this
 */
proto.Permissions.prototype.clearExplicit = function() {
  return this.setExplicit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Permissions.prototype.hasExplicit = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ExplicitPermissions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ExplicitPermissions.prototype.toObject = function(opt_includeInstance) {
  return proto.ExplicitPermissions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ExplicitPermissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ExplicitPermissions.toObject = function(includeInstance, msg) {
  var f, obj = {
    permissionsList: jspb.Message.toObjectList(msg.getPermissionsList(),
    proto.PermissionsType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ExplicitPermissions}
 */
proto.ExplicitPermissions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ExplicitPermissions;
  return proto.ExplicitPermissions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ExplicitPermissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ExplicitPermissions}
 */
proto.ExplicitPermissions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.PermissionsType;
      reader.readMessage(value,proto.PermissionsType.deserializeBinaryFromReader);
      msg.addPermissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ExplicitPermissions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ExplicitPermissions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ExplicitPermissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ExplicitPermissions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.PermissionsType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PermissionsType permissions = 1;
 * @return {!Array<!proto.PermissionsType>}
 */
proto.ExplicitPermissions.prototype.getPermissionsList = function() {
  return /** @type{!Array<!proto.PermissionsType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.PermissionsType, 1));
};


/**
 * @param {!Array<!proto.PermissionsType>} value
 * @return {!proto.ExplicitPermissions} returns this
*/
proto.ExplicitPermissions.prototype.setPermissionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.PermissionsType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PermissionsType}
 */
proto.ExplicitPermissions.prototype.addPermissions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PermissionsType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ExplicitPermissions} returns this
 */
proto.ExplicitPermissions.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.PermissionsType.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.PermissionsType.KindCase = {
  KIND_NOT_SET: 0,
  CACHE_PERMISSIONS: 1,
  TOPIC_PERMISSIONS: 2
};

/**
 * @return {proto.PermissionsType.KindCase}
 */
proto.PermissionsType.prototype.getKindCase = function() {
  return /** @type {proto.PermissionsType.KindCase} */(jspb.Message.computeOneofCase(this, proto.PermissionsType.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PermissionsType.prototype.toObject = function(opt_includeInstance) {
  return proto.PermissionsType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PermissionsType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.toObject = function(includeInstance, msg) {
  var f, obj = {
    cachePermissions: (f = msg.getCachePermissions()) && proto.PermissionsType.CachePermissions.toObject(includeInstance, f),
    topicPermissions: (f = msg.getTopicPermissions()) && proto.PermissionsType.TopicPermissions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PermissionsType}
 */
proto.PermissionsType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PermissionsType;
  return proto.PermissionsType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PermissionsType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PermissionsType}
 */
proto.PermissionsType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.PermissionsType.CachePermissions;
      reader.readMessage(value,proto.PermissionsType.CachePermissions.deserializeBinaryFromReader);
      msg.setCachePermissions(value);
      break;
    case 2:
      var value = new proto.PermissionsType.TopicPermissions;
      reader.readMessage(value,proto.PermissionsType.TopicPermissions.deserializeBinaryFromReader);
      msg.setTopicPermissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PermissionsType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PermissionsType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PermissionsType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCachePermissions();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.PermissionsType.CachePermissions.serializeBinaryToWriter
    );
  }
  f = message.getTopicPermissions();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.PermissionsType.TopicPermissions.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PermissionsType.All.prototype.toObject = function(opt_includeInstance) {
  return proto.PermissionsType.All.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PermissionsType.All} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.All.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PermissionsType.All}
 */
proto.PermissionsType.All.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PermissionsType.All;
  return proto.PermissionsType.All.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PermissionsType.All} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PermissionsType.All}
 */
proto.PermissionsType.All.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PermissionsType.All.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PermissionsType.All.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PermissionsType.All} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.All.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.PermissionsType.CacheSelector.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.PermissionsType.CacheSelector.KindCase = {
  KIND_NOT_SET: 0,
  CACHE_NAME: 1
};

/**
 * @return {proto.PermissionsType.CacheSelector.KindCase}
 */
proto.PermissionsType.CacheSelector.prototype.getKindCase = function() {
  return /** @type {proto.PermissionsType.CacheSelector.KindCase} */(jspb.Message.computeOneofCase(this, proto.PermissionsType.CacheSelector.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PermissionsType.CacheSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.PermissionsType.CacheSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PermissionsType.CacheSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.CacheSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    cacheName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PermissionsType.CacheSelector}
 */
proto.PermissionsType.CacheSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PermissionsType.CacheSelector;
  return proto.PermissionsType.CacheSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PermissionsType.CacheSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PermissionsType.CacheSelector}
 */
proto.PermissionsType.CacheSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCacheName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PermissionsType.CacheSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PermissionsType.CacheSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PermissionsType.CacheSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.CacheSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string cache_name = 1;
 * @return {string}
 */
proto.PermissionsType.CacheSelector.prototype.getCacheName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PermissionsType.CacheSelector} returns this
 */
proto.PermissionsType.CacheSelector.prototype.setCacheName = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.PermissionsType.CacheSelector.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PermissionsType.CacheSelector} returns this
 */
proto.PermissionsType.CacheSelector.prototype.clearCacheName = function() {
  return jspb.Message.setOneofField(this, 1, proto.PermissionsType.CacheSelector.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.CacheSelector.prototype.hasCacheName = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.PermissionsType.CacheItemSelector.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.PermissionsType.CacheItemSelector.KindCase = {
  KIND_NOT_SET: 0,
  KEY: 1,
  KEY_PREFIX: 2
};

/**
 * @return {proto.PermissionsType.CacheItemSelector.KindCase}
 */
proto.PermissionsType.CacheItemSelector.prototype.getKindCase = function() {
  return /** @type {proto.PermissionsType.CacheItemSelector.KindCase} */(jspb.Message.computeOneofCase(this, proto.PermissionsType.CacheItemSelector.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PermissionsType.CacheItemSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.PermissionsType.CacheItemSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PermissionsType.CacheItemSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.CacheItemSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: msg.getKey_asB64(),
    keyPrefix: msg.getKeyPrefix_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PermissionsType.CacheItemSelector}
 */
proto.PermissionsType.CacheItemSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PermissionsType.CacheItemSelector;
  return proto.PermissionsType.CacheItemSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PermissionsType.CacheItemSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PermissionsType.CacheItemSelector}
 */
proto.PermissionsType.CacheItemSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setKeyPrefix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PermissionsType.CacheItemSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PermissionsType.CacheItemSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PermissionsType.CacheItemSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.CacheItemSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional bytes key = 1;
 * @return {string}
 */
proto.PermissionsType.CacheItemSelector.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes key = 1;
 * This is a type-conversion wrapper around `getKey()`
 * @return {string}
 */
proto.PermissionsType.CacheItemSelector.prototype.getKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getKey()));
};


/**
 * optional bytes key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getKey()`
 * @return {!Uint8Array}
 */
proto.PermissionsType.CacheItemSelector.prototype.getKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.PermissionsType.CacheItemSelector} returns this
 */
proto.PermissionsType.CacheItemSelector.prototype.setKey = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.PermissionsType.CacheItemSelector.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PermissionsType.CacheItemSelector} returns this
 */
proto.PermissionsType.CacheItemSelector.prototype.clearKey = function() {
  return jspb.Message.setOneofField(this, 1, proto.PermissionsType.CacheItemSelector.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.CacheItemSelector.prototype.hasKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes key_prefix = 2;
 * @return {string}
 */
proto.PermissionsType.CacheItemSelector.prototype.getKeyPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes key_prefix = 2;
 * This is a type-conversion wrapper around `getKeyPrefix()`
 * @return {string}
 */
proto.PermissionsType.CacheItemSelector.prototype.getKeyPrefix_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getKeyPrefix()));
};


/**
 * optional bytes key_prefix = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getKeyPrefix()`
 * @return {!Uint8Array}
 */
proto.PermissionsType.CacheItemSelector.prototype.getKeyPrefix_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getKeyPrefix()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.PermissionsType.CacheItemSelector} returns this
 */
proto.PermissionsType.CacheItemSelector.prototype.setKeyPrefix = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.PermissionsType.CacheItemSelector.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PermissionsType.CacheItemSelector} returns this
 */
proto.PermissionsType.CacheItemSelector.prototype.clearKeyPrefix = function() {
  return jspb.Message.setOneofField(this, 2, proto.PermissionsType.CacheItemSelector.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.CacheItemSelector.prototype.hasKeyPrefix = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.PermissionsType.CachePermissions.oneofGroups_ = [[2,3],[4,5]];

/**
 * @enum {number}
 */
proto.PermissionsType.CachePermissions.CacheCase = {
  CACHE_NOT_SET: 0,
  ALL_CACHES: 2,
  CACHE_SELECTOR: 3
};

/**
 * @return {proto.PermissionsType.CachePermissions.CacheCase}
 */
proto.PermissionsType.CachePermissions.prototype.getCacheCase = function() {
  return /** @type {proto.PermissionsType.CachePermissions.CacheCase} */(jspb.Message.computeOneofCase(this, proto.PermissionsType.CachePermissions.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.PermissionsType.CachePermissions.CacheItemCase = {
  CACHE_ITEM_NOT_SET: 0,
  ALL_ITEMS: 4,
  ITEM_SELECTOR: 5
};

/**
 * @return {proto.PermissionsType.CachePermissions.CacheItemCase}
 */
proto.PermissionsType.CachePermissions.prototype.getCacheItemCase = function() {
  return /** @type {proto.PermissionsType.CachePermissions.CacheItemCase} */(jspb.Message.computeOneofCase(this, proto.PermissionsType.CachePermissions.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PermissionsType.CachePermissions.prototype.toObject = function(opt_includeInstance) {
  return proto.PermissionsType.CachePermissions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PermissionsType.CachePermissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.CachePermissions.toObject = function(includeInstance, msg) {
  var f, obj = {
    role: jspb.Message.getFieldWithDefault(msg, 1, 0),
    allCaches: (f = msg.getAllCaches()) && proto.PermissionsType.All.toObject(includeInstance, f),
    cacheSelector: (f = msg.getCacheSelector()) && proto.PermissionsType.CacheSelector.toObject(includeInstance, f),
    allItems: (f = msg.getAllItems()) && proto.PermissionsType.All.toObject(includeInstance, f),
    itemSelector: (f = msg.getItemSelector()) && proto.PermissionsType.CacheItemSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PermissionsType.CachePermissions}
 */
proto.PermissionsType.CachePermissions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PermissionsType.CachePermissions;
  return proto.PermissionsType.CachePermissions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PermissionsType.CachePermissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PermissionsType.CachePermissions}
 */
proto.PermissionsType.CachePermissions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.CacheRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 2:
      var value = new proto.PermissionsType.All;
      reader.readMessage(value,proto.PermissionsType.All.deserializeBinaryFromReader);
      msg.setAllCaches(value);
      break;
    case 3:
      var value = new proto.PermissionsType.CacheSelector;
      reader.readMessage(value,proto.PermissionsType.CacheSelector.deserializeBinaryFromReader);
      msg.setCacheSelector(value);
      break;
    case 4:
      var value = new proto.PermissionsType.All;
      reader.readMessage(value,proto.PermissionsType.All.deserializeBinaryFromReader);
      msg.setAllItems(value);
      break;
    case 5:
      var value = new proto.PermissionsType.CacheItemSelector;
      reader.readMessage(value,proto.PermissionsType.CacheItemSelector.deserializeBinaryFromReader);
      msg.setItemSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PermissionsType.CachePermissions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PermissionsType.CachePermissions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PermissionsType.CachePermissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.CachePermissions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAllCaches();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.PermissionsType.All.serializeBinaryToWriter
    );
  }
  f = message.getCacheSelector();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.PermissionsType.CacheSelector.serializeBinaryToWriter
    );
  }
  f = message.getAllItems();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.PermissionsType.All.serializeBinaryToWriter
    );
  }
  f = message.getItemSelector();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.PermissionsType.CacheItemSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional CacheRole role = 1;
 * @return {!proto.CacheRole}
 */
proto.PermissionsType.CachePermissions.prototype.getRole = function() {
  return /** @type {!proto.CacheRole} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.CacheRole} value
 * @return {!proto.PermissionsType.CachePermissions} returns this
 */
proto.PermissionsType.CachePermissions.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional All all_caches = 2;
 * @return {?proto.PermissionsType.All}
 */
proto.PermissionsType.CachePermissions.prototype.getAllCaches = function() {
  return /** @type{?proto.PermissionsType.All} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.All, 2));
};


/**
 * @param {?proto.PermissionsType.All|undefined} value
 * @return {!proto.PermissionsType.CachePermissions} returns this
*/
proto.PermissionsType.CachePermissions.prototype.setAllCaches = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.PermissionsType.CachePermissions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType.CachePermissions} returns this
 */
proto.PermissionsType.CachePermissions.prototype.clearAllCaches = function() {
  return this.setAllCaches(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.CachePermissions.prototype.hasAllCaches = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CacheSelector cache_selector = 3;
 * @return {?proto.PermissionsType.CacheSelector}
 */
proto.PermissionsType.CachePermissions.prototype.getCacheSelector = function() {
  return /** @type{?proto.PermissionsType.CacheSelector} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.CacheSelector, 3));
};


/**
 * @param {?proto.PermissionsType.CacheSelector|undefined} value
 * @return {!proto.PermissionsType.CachePermissions} returns this
*/
proto.PermissionsType.CachePermissions.prototype.setCacheSelector = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.PermissionsType.CachePermissions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType.CachePermissions} returns this
 */
proto.PermissionsType.CachePermissions.prototype.clearCacheSelector = function() {
  return this.setCacheSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.CachePermissions.prototype.hasCacheSelector = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional All all_items = 4;
 * @return {?proto.PermissionsType.All}
 */
proto.PermissionsType.CachePermissions.prototype.getAllItems = function() {
  return /** @type{?proto.PermissionsType.All} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.All, 4));
};


/**
 * @param {?proto.PermissionsType.All|undefined} value
 * @return {!proto.PermissionsType.CachePermissions} returns this
*/
proto.PermissionsType.CachePermissions.prototype.setAllItems = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.PermissionsType.CachePermissions.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType.CachePermissions} returns this
 */
proto.PermissionsType.CachePermissions.prototype.clearAllItems = function() {
  return this.setAllItems(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.CachePermissions.prototype.hasAllItems = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CacheItemSelector item_selector = 5;
 * @return {?proto.PermissionsType.CacheItemSelector}
 */
proto.PermissionsType.CachePermissions.prototype.getItemSelector = function() {
  return /** @type{?proto.PermissionsType.CacheItemSelector} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.CacheItemSelector, 5));
};


/**
 * @param {?proto.PermissionsType.CacheItemSelector|undefined} value
 * @return {!proto.PermissionsType.CachePermissions} returns this
*/
proto.PermissionsType.CachePermissions.prototype.setItemSelector = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.PermissionsType.CachePermissions.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType.CachePermissions} returns this
 */
proto.PermissionsType.CachePermissions.prototype.clearItemSelector = function() {
  return this.setItemSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.CachePermissions.prototype.hasItemSelector = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.PermissionsType.TopicSelector.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.PermissionsType.TopicSelector.KindCase = {
  KIND_NOT_SET: 0,
  TOPIC_NAME: 1,
  TOPIC_NAME_PREFIX: 2
};

/**
 * @return {proto.PermissionsType.TopicSelector.KindCase}
 */
proto.PermissionsType.TopicSelector.prototype.getKindCase = function() {
  return /** @type {proto.PermissionsType.TopicSelector.KindCase} */(jspb.Message.computeOneofCase(this, proto.PermissionsType.TopicSelector.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PermissionsType.TopicSelector.prototype.toObject = function(opt_includeInstance) {
  return proto.PermissionsType.TopicSelector.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PermissionsType.TopicSelector} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.TopicSelector.toObject = function(includeInstance, msg) {
  var f, obj = {
    topicName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    topicNamePrefix: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PermissionsType.TopicSelector}
 */
proto.PermissionsType.TopicSelector.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PermissionsType.TopicSelector;
  return proto.PermissionsType.TopicSelector.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PermissionsType.TopicSelector} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PermissionsType.TopicSelector}
 */
proto.PermissionsType.TopicSelector.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopicName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopicNamePrefix(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PermissionsType.TopicSelector.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PermissionsType.TopicSelector.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PermissionsType.TopicSelector} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.TopicSelector.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string topic_name = 1;
 * @return {string}
 */
proto.PermissionsType.TopicSelector.prototype.getTopicName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PermissionsType.TopicSelector} returns this
 */
proto.PermissionsType.TopicSelector.prototype.setTopicName = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.PermissionsType.TopicSelector.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PermissionsType.TopicSelector} returns this
 */
proto.PermissionsType.TopicSelector.prototype.clearTopicName = function() {
  return jspb.Message.setOneofField(this, 1, proto.PermissionsType.TopicSelector.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.TopicSelector.prototype.hasTopicName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string topic_name_prefix = 2;
 * @return {string}
 */
proto.PermissionsType.TopicSelector.prototype.getTopicNamePrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PermissionsType.TopicSelector} returns this
 */
proto.PermissionsType.TopicSelector.prototype.setTopicNamePrefix = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.PermissionsType.TopicSelector.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PermissionsType.TopicSelector} returns this
 */
proto.PermissionsType.TopicSelector.prototype.clearTopicNamePrefix = function() {
  return jspb.Message.setOneofField(this, 2, proto.PermissionsType.TopicSelector.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.TopicSelector.prototype.hasTopicNamePrefix = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.PermissionsType.TopicPermissions.oneofGroups_ = [[2,3],[4,5]];

/**
 * @enum {number}
 */
proto.PermissionsType.TopicPermissions.CacheCase = {
  CACHE_NOT_SET: 0,
  ALL_CACHES: 2,
  CACHE_SELECTOR: 3
};

/**
 * @return {proto.PermissionsType.TopicPermissions.CacheCase}
 */
proto.PermissionsType.TopicPermissions.prototype.getCacheCase = function() {
  return /** @type {proto.PermissionsType.TopicPermissions.CacheCase} */(jspb.Message.computeOneofCase(this, proto.PermissionsType.TopicPermissions.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.PermissionsType.TopicPermissions.TopicCase = {
  TOPIC_NOT_SET: 0,
  ALL_TOPICS: 4,
  TOPIC_SELECTOR: 5
};

/**
 * @return {proto.PermissionsType.TopicPermissions.TopicCase}
 */
proto.PermissionsType.TopicPermissions.prototype.getTopicCase = function() {
  return /** @type {proto.PermissionsType.TopicPermissions.TopicCase} */(jspb.Message.computeOneofCase(this, proto.PermissionsType.TopicPermissions.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PermissionsType.TopicPermissions.prototype.toObject = function(opt_includeInstance) {
  return proto.PermissionsType.TopicPermissions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PermissionsType.TopicPermissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.TopicPermissions.toObject = function(includeInstance, msg) {
  var f, obj = {
    role: jspb.Message.getFieldWithDefault(msg, 1, 0),
    allCaches: (f = msg.getAllCaches()) && proto.PermissionsType.All.toObject(includeInstance, f),
    cacheSelector: (f = msg.getCacheSelector()) && proto.PermissionsType.CacheSelector.toObject(includeInstance, f),
    allTopics: (f = msg.getAllTopics()) && proto.PermissionsType.All.toObject(includeInstance, f),
    topicSelector: (f = msg.getTopicSelector()) && proto.PermissionsType.TopicSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PermissionsType.TopicPermissions}
 */
proto.PermissionsType.TopicPermissions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PermissionsType.TopicPermissions;
  return proto.PermissionsType.TopicPermissions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PermissionsType.TopicPermissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PermissionsType.TopicPermissions}
 */
proto.PermissionsType.TopicPermissions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.TopicRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    case 2:
      var value = new proto.PermissionsType.All;
      reader.readMessage(value,proto.PermissionsType.All.deserializeBinaryFromReader);
      msg.setAllCaches(value);
      break;
    case 3:
      var value = new proto.PermissionsType.CacheSelector;
      reader.readMessage(value,proto.PermissionsType.CacheSelector.deserializeBinaryFromReader);
      msg.setCacheSelector(value);
      break;
    case 4:
      var value = new proto.PermissionsType.All;
      reader.readMessage(value,proto.PermissionsType.All.deserializeBinaryFromReader);
      msg.setAllTopics(value);
      break;
    case 5:
      var value = new proto.PermissionsType.TopicSelector;
      reader.readMessage(value,proto.PermissionsType.TopicSelector.deserializeBinaryFromReader);
      msg.setTopicSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PermissionsType.TopicPermissions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PermissionsType.TopicPermissions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PermissionsType.TopicPermissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PermissionsType.TopicPermissions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAllCaches();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.PermissionsType.All.serializeBinaryToWriter
    );
  }
  f = message.getCacheSelector();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.PermissionsType.CacheSelector.serializeBinaryToWriter
    );
  }
  f = message.getAllTopics();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.PermissionsType.All.serializeBinaryToWriter
    );
  }
  f = message.getTopicSelector();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.PermissionsType.TopicSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional TopicRole role = 1;
 * @return {!proto.TopicRole}
 */
proto.PermissionsType.TopicPermissions.prototype.getRole = function() {
  return /** @type {!proto.TopicRole} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.TopicRole} value
 * @return {!proto.PermissionsType.TopicPermissions} returns this
 */
proto.PermissionsType.TopicPermissions.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional All all_caches = 2;
 * @return {?proto.PermissionsType.All}
 */
proto.PermissionsType.TopicPermissions.prototype.getAllCaches = function() {
  return /** @type{?proto.PermissionsType.All} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.All, 2));
};


/**
 * @param {?proto.PermissionsType.All|undefined} value
 * @return {!proto.PermissionsType.TopicPermissions} returns this
*/
proto.PermissionsType.TopicPermissions.prototype.setAllCaches = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.PermissionsType.TopicPermissions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType.TopicPermissions} returns this
 */
proto.PermissionsType.TopicPermissions.prototype.clearAllCaches = function() {
  return this.setAllCaches(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.TopicPermissions.prototype.hasAllCaches = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CacheSelector cache_selector = 3;
 * @return {?proto.PermissionsType.CacheSelector}
 */
proto.PermissionsType.TopicPermissions.prototype.getCacheSelector = function() {
  return /** @type{?proto.PermissionsType.CacheSelector} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.CacheSelector, 3));
};


/**
 * @param {?proto.PermissionsType.CacheSelector|undefined} value
 * @return {!proto.PermissionsType.TopicPermissions} returns this
*/
proto.PermissionsType.TopicPermissions.prototype.setCacheSelector = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.PermissionsType.TopicPermissions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType.TopicPermissions} returns this
 */
proto.PermissionsType.TopicPermissions.prototype.clearCacheSelector = function() {
  return this.setCacheSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.TopicPermissions.prototype.hasCacheSelector = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional All all_topics = 4;
 * @return {?proto.PermissionsType.All}
 */
proto.PermissionsType.TopicPermissions.prototype.getAllTopics = function() {
  return /** @type{?proto.PermissionsType.All} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.All, 4));
};


/**
 * @param {?proto.PermissionsType.All|undefined} value
 * @return {!proto.PermissionsType.TopicPermissions} returns this
*/
proto.PermissionsType.TopicPermissions.prototype.setAllTopics = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.PermissionsType.TopicPermissions.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType.TopicPermissions} returns this
 */
proto.PermissionsType.TopicPermissions.prototype.clearAllTopics = function() {
  return this.setAllTopics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.TopicPermissions.prototype.hasAllTopics = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional TopicSelector topic_selector = 5;
 * @return {?proto.PermissionsType.TopicSelector}
 */
proto.PermissionsType.TopicPermissions.prototype.getTopicSelector = function() {
  return /** @type{?proto.PermissionsType.TopicSelector} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.TopicSelector, 5));
};


/**
 * @param {?proto.PermissionsType.TopicSelector|undefined} value
 * @return {!proto.PermissionsType.TopicPermissions} returns this
*/
proto.PermissionsType.TopicPermissions.prototype.setTopicSelector = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.PermissionsType.TopicPermissions.oneofGroups_[1], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType.TopicPermissions} returns this
 */
proto.PermissionsType.TopicPermissions.prototype.clearTopicSelector = function() {
  return this.setTopicSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.TopicPermissions.prototype.hasTopicSelector = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional CachePermissions cache_permissions = 1;
 * @return {?proto.PermissionsType.CachePermissions}
 */
proto.PermissionsType.prototype.getCachePermissions = function() {
  return /** @type{?proto.PermissionsType.CachePermissions} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.CachePermissions, 1));
};


/**
 * @param {?proto.PermissionsType.CachePermissions|undefined} value
 * @return {!proto.PermissionsType} returns this
*/
proto.PermissionsType.prototype.setCachePermissions = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.PermissionsType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType} returns this
 */
proto.PermissionsType.prototype.clearCachePermissions = function() {
  return this.setCachePermissions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.prototype.hasCachePermissions = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TopicPermissions topic_permissions = 2;
 * @return {?proto.PermissionsType.TopicPermissions}
 */
proto.PermissionsType.prototype.getTopicPermissions = function() {
  return /** @type{?proto.PermissionsType.TopicPermissions} */ (
    jspb.Message.getWrapperField(this, proto.PermissionsType.TopicPermissions, 2));
};


/**
 * @param {?proto.PermissionsType.TopicPermissions|undefined} value
 * @return {!proto.PermissionsType} returns this
*/
proto.PermissionsType.prototype.setTopicPermissions = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.PermissionsType.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PermissionsType} returns this
 */
proto.PermissionsType.prototype.clearTopicPermissions = function() {
  return this.setTopicPermissions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PermissionsType.prototype.hasTopicPermissions = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.CacheRole = {
  CACHEPERMITNONE: 0,
  CACHEREADWRITE: 1,
  CACHEREADONLY: 2,
  CACHEWRITEONLY: 3
};

/**
 * @enum {number}
 */
proto.TopicRole = {
  TOPICPERMITNONE: 0,
  TOPICREADWRITE: 1,
  TOPICREADONLY: 2,
  TOPICWRITEONLY: 3
};

/**
 * @enum {number}
 */
proto.SuperUserPermissions = {
  SUPERUSER: 0
};

goog.object.extend(exports, proto);
